import { createPortal } from "react-dom";
import useTranslator from "../../hooks/useTranslator";
import "./StopSharingModal.css";

/**
 * Confirmation before stopping sharing an application with a landlord.
 * Applies to every member of the application, so they are listed.
 */
const StopSharingModal = ({
  landlordName,
  applicationTitle,
  memberNames = [],
  processing = false,
  onCancel,
  onConfirm,
}) => {
  const { _t, i18n } = useTranslator();
  const language = String(i18n?.language || "en").split("-")[0];
  let members = memberNames.join(", ");
  try {
    // en-GB: "A, B and C" (no comma before "and")
    members = new Intl.ListFormat(language === "en" ? "en-GB" : language, {
      style: "long",
      type: "conjunction",
    }).format(memberNames);
  } catch {
    // Intl.ListFormat unavailable: keep the comma list
  }

  return createPortal(
    <div className="ssm-overlay" onClick={() => !processing && onCancel()}>
      <div
        className="ssm-modal"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="ssm-close"
          aria-label={_t("close")}
          disabled={processing}
          onClick={onCancel}
        >
          ✕
        </button>
        <h2 className="ssm-title">
          {_t("stopSharingThisApplicationWith")} {landlordName}?
        </h2>
        <p className="ssm-text">
          {landlordName} {_t("willNoLongerSee")}{" "}
          <strong>{applicationTitle}</strong>.
          {memberNames.length > 0 && (
            <>
              {" "}
              {_t("appliesToEveryoneInIt")} {members}.
            </>
          )}
        </p>
        <div className="ssm-actions">
          <button
            type="button"
            className="ssm-cancel"
            disabled={processing}
            onClick={onCancel}
          >
            {_t("cancel")}
          </button>
          <button
            type="button"
            className="ssm-confirm"
            disabled={processing}
            onClick={onConfirm}
          >
            {processing ? "..." : _t("stopSharing")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StopSharingModal;
